import React, { useCallback } from 'react';
import "../../styles/home/view_cast_details.css";
import { useEffect, useState } from "react";
import { getCastDetails } from "../repositories/movies_and_tvseries";

import noImage from "../../images/collections/no_image.png";

const ViewCastDetails = ({getShow, setShow, getCastId}) => {
    const [getCastImage, setCastImage] = useState("");
    const [getCastName, setCastName] = useState("");
    const [getCastOtherNames, setCastOtherNames] = useState("");
    const [getCastBio, setCastBio] = useState("");
    const [getCastBirthday, setCastBirthday] = useState("");
    const [getCastDeathday, setCastDeathday] = useState("");
    const [getCastAge, setCastAge] = useState("");
    const [getCastHomePage, setCastHomePage] = useState("");
    const [getCastPlaceBirth, setCastPlaceBirth] = useState("");
    const [getCastDepartment, setCastDepartment] = useState("");

    const calculateCastAge = useCallback((birthday, deathday) => {
        setCastAge("");
        let deathDate;
        let age = 0;
        const birthDate = new Date(birthday);
        const today = new Date();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        if (deathday === "" || deathday == null) {
            deathDate = null;
        }else{
            deathDate = new Date(deathday);
        }

        if (deathDate === "" || deathDate == null) {
            age = today.getFullYear() - birthDate.getFullYear();
        } else {
            age = deathDate.getFullYear() - birthDate.getFullYear();
        };
        
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        };
        
        setCastAge(age.toFixed());
    });


    const retrieveCastDetails = useCallback(async () => {
        const castDetails = await getCastDetails(getCastId);
        setCastImage(castDetails["profile_path"]);
        setCastName(castDetails["name"]);
        setCastBio(castDetails["biography"]);
        setCastBirthday(castDetails["birthday"]);
        setCastDeathday(castDetails["deathday"]);
        setCastHomePage(castDetails["homepage"]);
        setCastPlaceBirth(castDetails["place_of_birth"]);
        setCastDepartment(castDetails["known_for_department"]);

        if (castDetails["also_known_as"] == null || castDetails["also_known_as"].length <= 0) {
            setCastOtherNames("")
        } else {
            setCastOtherNames(castDetails["also_known_as"].join(", "));
        }

        if (castDetails["birthday"] === "" || castDetails["birthday"] == null) {
            
        }else{
            calculateCastAge(castDetails["birthday"], castDetails["deathday"])
        }
    }, [getCastId, calculateCastAge]);

    const viewUrl = (url) => {
        if (url !== "" || url !== null) {
            window.open(url, '_blank');
        };
    };

    useEffect(() => {
        setCastImage("");
        setCastName("");
        setCastOtherNames("");
        setCastBio("");
        setCastBirthday("");
        setCastDeathday("");
        setCastHomePage("");
        setCastPlaceBirth("");
        setCastDepartment("");
        setCastAge("");
        retrieveCastDetails();
    }, [getCastId]);

    return(
        <div className={`view_cast_details_dialog ${getShow ? "show" : ""}`}>
            <div className="view_cast_details_overlay" onClick={() => setShow(false)}></div>
            <div className="view_cast_details_content">
                <img className="view_cast_details_content_image" alt={getCastName} src={getCastImage === "" || getCastImage == null ? noImage : `https://image.tmdb.org/t/p/w500${getCastImage}`} />
                <p className="view_cast_details_content_name">{getCastName === "" || getCastName == null ? "Unavailable" : getCastName}</p>

                <div className="view_cast_details_content_details_column">
                    {
                        getCastBio === "" || getCastBio == null
                        ? null
                        : <p className="view_cast_details_content_bio">{getCastBio}</p>
                    }

                    {
                        getCastOtherNames === "" || getCastOtherNames == null
                        ? null
                        : <div className="view_cast_details_content_details_row">
                            <p className="view_cast_details_content_subhead">Other Names: </p>
                            <p className="view_cast_details_content_details">{getCastOtherNames}</p>
                        </div>
                    }

                    {
                        getCastAge === "" || getCastAge == null
                        ? null
                        : <div className="view_cast_details_content_details_row">
                            <p className="view_cast_details_content_subhead">Age: </p>
                            <p className="view_cast_details_content_details">{getCastAge}</p>
                        </div>
                    }

                    {
                        getCastBirthday === "" || getCastBirthday == null
                        ? null
                        : <div className="view_cast_details_content_details_row">
                            <p className="view_cast_details_content_subhead">Birthday: </p>
                            <p className="view_cast_details_content_details">{getCastBirthday}</p>
                        </div>
                    }

                    {
                        getCastDeathday === "" || getCastDeathday == null
                        ? null
                        : <div className="view_cast_details_content_details_row">
                            <p className="view_cast_details_content_subhead">Deathday: </p>
                            <p className="view_cast_details_content_details">{getCastDeathday}</p>
                        </div>
                    }

                    {
                        getCastPlaceBirth === "" || getCastPlaceBirth == null
                        ? null
                        : <div className="view_cast_details_content_details_row">
                            <p className="view_cast_details_content_subhead">Place of Birth: </p>
                            <p className="view_cast_details_content_details">{getCastPlaceBirth}</p>
                        </div>
                    }

                    {
                        getCastDepartment === "" || getCastDepartment == null
                        ? null
                        : <div className="view_cast_details_content_details_row">
                            <p className="view_cast_details_content_subhead">Department: </p>
                            <p className="view_cast_details_content_details">{getCastDepartment}</p>
                        </div>
                    }

                    {
                        getCastHomePage === "" || getCastHomePage == null
                        ? null
                        : <div className="view_cast_details_content_details_row">
                            <p className="view_cast_details_content_subhead">Homepage: </p>
                            <p className="view_cast_details_content_homepage" onClick={() => viewUrl(getCastHomePage)}>{getCastHomePage}</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default ViewCastDetails;